<template lang="pug">
  p 4-uhoh-4! Page Not Found.
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
  p{
    font-size: 50px;
    color: #850a0a;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/NotFound.vue